import { render, staticRenderFns } from "./TopTabs.vue?vue&type=template&id=182d8c33&scoped=true"
import script from "./TopTabs.vue?vue&type=script&lang=js"
export * from "./TopTabs.vue?vue&type=script&lang=js"
import style0 from "./TopTabs.vue?vue&type=style&index=0&id=182d8c33&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "182d8c33",
  null
  
)

export default component.exports